import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs/operators';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

/**
 * Direct Cap Cap Rate Reconciliation Widget
 */
@Component({
  selector: 'cap-rate-reconciliation-widget',
  templateUrl: './cap-rate-reconciliation-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './cap-rate-reconciliation-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CapRateReconciliationWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("capRateReconciliation", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('capRateReconciliation').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('capRateReconciliation', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(injector: Injector) {
    super(injector, 'capRateReconciliation', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    data.showFirstRow = data.usCapRateReconciliationMarketExtractedRatesRangeFrom || data.usCapRateReconciliationMarketExtractedRatesAverage || data.usCapRateReconciliationMarketExtractedRatesMedian || data.usCapRateReconciliationMarketExtractedRatesRange || data.usCapRateReconciliationMarketExtractedRatesRangeTo;
    data.showSecondRow = data.usCapRateReconciliationBandOfInvestmentRange || data.usCapRateReconciliationBandOfInvestmentAverage || data.usCapRateReconciliationBandOfInvestmentMedian;
    data.showThirdRow = data.usCapRateReconciliationDebtCoverageRatioRange || data.usCapRateReconciliationDebtCoverageRatioAverage || data.usCapRateReconciliationDebtCoverageRatioMedian;
    data.showFourthRow = data.usCapRateReconciliationPublishedInvestorSurveysRangeFrom || data.usCapRateReconciliationPublishedInvestorSurveysAverage || data.usCapRateReconciliationPublishedInvestorSurveysMedian || data.usCapRateReconciliationPublishedInvestorSurveysRange || data.usCapRateReconciliationPublishedInvestorSurveysRangeTo;
    data.showFifthRow = data.usCapRateReconciliationMarketExpertInterviewsRangeFrom || data.usCapRateReconciliationMarketExpertInterviewsAverage || data.usCapRateReconciliationMarketExpertInterviewsMedian || data.usCapRateReconciliationMarketExpertInterviewsRange || data.usCapRateReconciliationMarketExpertInterviewsRangeTo;
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return 2 + (this.widgetData.showFirstRow ? 1 : 0) + (this.widgetData.showSecondRow ? 1 : 0) + (this.widgetData.showThirdRow ? 1 : 0) + (this.widgetData.showFourthRow ? 1 : 0) + (this.widgetData.showFifthRow ? 1 : 0) + (this.widgetData.usCapRateReconciliationJLLProjectionMedian ? 1 : 0) + (this.widgetData.usCapRateReconciliationJLLProjection2Median ? 1 : 0) - 1;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}
